










































































































































import Vue from "vue";
import Component from "vue-class-component";
import {
  CatalogDeleteCatalogResponseApiRespoonse,
  CatalogsManagerService as catalogApi,
} from "@/common/api";
import Catalog from "@/model/catalog";
import { CATEGORIES } from "@/model/catalog";
import QErrors from "@/common/qErrors.vue";
import uploadSingleImage from "@/components/common/uploadSingleImage.vue";
import { formatImageUrl } from "@/common/utils";
import uploadFile from "@/components/common/uploadFile.vue";
import { CatalogCreateCatalogResponseApiRespoonse } from "@/common/api";
import qNotify from "@/common/qNotify";

@Component({
  name: "CatalogEdit",
  components: {
    QErrors,
    uploadSingleImage,
    uploadFile,
  },
})
export default class CatalogEdit extends Vue {
  public errorStyle = {
    maxWidth: "100%",
  };
  public isShow = false;
  public catalog: any = new Catalog();
  public errors: any = {};
  public catalogImage: any = {};
  public uploadOptions = {
    acceptedFiles: ".jpg,.png,.jpeg",
  };

  public excelFiles = [];
  public excelFileUploadStatus = "";
  public catalogId = null;
  public isEdit = false;

  get isExcelFileUploading() {
    return this.excelFileUploadStatus === "uploading";
  }

  public pdfFiles = [];
  public pdfFileUploadStatus = "";

  get isPdfFileUploading() {
    return this.pdfFileUploadStatus === "uploading";
  }

  public uploading = false;
  public catalogImageSize = "500x158";

  get categories() {
    return CATEGORIES;
  }

  public created() {
    console.log("catalog", this.catalog);
  }

  public show(catalog = null) {
    this.isShow = true;
    this.catalogImage = null;
    this.excelFiles = [];
    this.pdfFiles = [];
    this.errors = {};

    // Always scroll to top
    this.$el.querySelector(".mb__popup-contents").scrollTop = 0;

    if (catalog) {
      this.isEdit = true;
      this.catalog = {
        id: catalog.id,
        category: catalog.category,
        title: catalog.title,
        sub_title: catalog.sub_title,
        page_count: catalog.page_count,
        catalog_url: catalog.catalog_url,
        image_id: catalog.image ? catalog.image.id : null,
        image_url: catalog.image_url,
      };
      console.log(catalog.image_url);
      this.catalogImage = catalog.image_url;
    } else {
      this.catalog = new Catalog();
    }
  }

  public close() {
    this.errors = {};
    this.isShow = false;
  }

  public changeImage(image) {
    this.catalog.image_id = image ? image.id : null;
    this.catalogImage = image ? image.fullUrl : null;
  }

  public changeInput(key) {
    this.errors = { ...this.errors, ...{ [key]: [] } };
  }

  public async submit() {
    let response = null;

    if (this.catalog.id) {
      try {
        response = await catalogApi.catalogsUpdate(this.catalog);
      } catch (error) {
        response = error;
      }
    } else {
      try {
        response = await catalogApi.catalogsCreate(this.catalog);
      } catch (error) {
        response = error;
      }
    }

    if (
      response.status == CatalogCreateCatalogResponseApiRespoonse.status.SUCCESS
    ) {
      qNotify.success({
        text: this.$t("common.message.created"),
      });
      this.isShow = false;
      this.$emit("closeAdded");
    } else if (response.status == "400") {
      this.errors = response.body.errors;
    } else {
      qNotify.error({
        text: response.body.message,
      });
    }
  }

  public uploadStatus(flag) {
    this.uploading = flag;
  }

  public formatImageUrl(image) {
    return this.catalog.image_id ? image : "";
  }

  public showDeleteConfirm() {
    this.errors = {};
    this.$modal.showDelete({
      text: this.$t("common.modal.delete_content"),
      onConfirm: () => {
        this.deleteOtherIr();
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  async deleteOtherIr() {
    let result;
    try {
      result = await catalogApi.catalogsDelete({
        id: this.catalog.id,
      });
    } catch (error) {
      result = error;
    }

    if (
      result.status == CatalogDeleteCatalogResponseApiRespoonse.status.SUCCESS
    ) {
      qNotify.success({
        text: this.$t("common.message.deleted"),
      });
      this.isShow = false;
      this.$emit("closeEdited");
    } else if (result.status == "400") {
      this.errors = result.body.errors;
    } else {
      qNotify.error({
        text: result.body.message,
      });
    }
  }
}
